import { useEffect, useRef, useState, useCallback } from 'react';

const timeout = (func: () => void, time: number) => setTimeout(() => func(), time);

const useTimeoutToggler = (time: number): [boolean, () => void] => {
  const [isTimedOut, setIsTimedOut] = useState(false);

  const toggleTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = useCallback(() => {
    if (toggleTimeout.current) {
      clearTimeout(toggleTimeout.current);
    }
    setIsTimedOut(false);
    toggleTimeout.current = timeout(() => setIsTimedOut(true), time);
  }, [time]);

  useEffect(() => {
    toggleTimeout.current = timeout(() => setIsTimedOut(true), time);
    return () => {
      if (toggleTimeout.current) {
        clearTimeout(toggleTimeout.current);
      }
    };
  }, [toggleTimeout, time]);

  return [isTimedOut, resetTimer];
};

export default useTimeoutToggler;
